<template>
	<div class="task-document">
		<h4>{{data.name}}</h4>
		<div class="task-document-block" v-for="(item,index) in documents" :key="index">
			<select :name="'doc_types['+group+']['+index+']'">
				<option v-for="item in data.list" :value="item.id" :key="item.id">{{item.name}}</option>
			</select>
			<button type="button" class="task-document-remove" v-on:click="remove(index)"></button>
		</div>
		<button type="button" class="task-document-add" v-on:click="add">Добавить документ</button>
	</div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    group: {
      type: Number,
      required: true
    }
  },
  data: function() {
    return {
      documents: []
    };
  },
  methods: {
    add: function() {
      if (this.documents.length > 0) {
        this.documents.push(this.documents[this.documents.length - 1] + 1);
      } else {
        this.documents.push(1);
      }
    },
    remove: function(index) {
      this.documents.splice(index, 1);
    }
  }
};
</script>

<style scoped>
.task-document {
  padding: 20px;
  background-color: #f5f5f5;
  width: 100%;
  height: 100%;
}

.task-document-block {
  position: relative;
}

.task-document-block select {
  color: #4caf50;
  margin-bottom: 15px;
}

.task-document-remove {
  background: transparent;
  border-radius: 0;
  border: 0;
  padding: 0;
  margin: 0;
  width: 8px;
  height: 8px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4Ij48ZGVmcz48cGF0aCBpZD0idzAzNWEiIGQ9Ik00NDAgNTc4LjhsLS44LS44LTMuMiAzLjItMy4yLTMuMi0uOC44IDMuMiAzLjItMy4yIDMuMi44LjggMy4yLTMuMiAzLjIgMy4yLjgtLjgtMy4yLTMuMnoiLz48L2RlZnM+PGc+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQzMiAtNTc4KSI+PHVzZSBmaWxsPSIjOWJhM2FmIiB4bGluazpocmVmPSIjdzAzNWEiLz48L2c+PC9nPjwvc3ZnPg==");
  position: absolute;
  right: 0;
  top: 16px;
}

.task-document-add {
  background: transparent;
  border-radius: 0;
  border: 0;
  padding: 0;
  margin: 0;
  font-size: 12px;
  color: #4e515e;
  display: flex;
  align-items: center;
}
.task-document-add:before {
  content: "";
  display: inline-block;
  width: 18px;
  height: 18px;
  margin-right: 10px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCI+PGRlZnM+PHBhdGggaWQ9ImM4bW1hIiBkPSJNMzg2LjQ1IDQzMi42MmgzLjdhLjQxLjQxIDAgMSAxIDAgLjgzaC0zLjd2My43YS40MS40MSAwIDAgMS0uODMgMHYtMy43aC0zLjdhLjQxLjQxIDAgMSAxIDAtLjgzaDMuN3YtMy43YS40MS40MSAwIDEgMSAuODMgMHoiLz48cGF0aCBpZD0iYzhtbWIiIGQ9Ik0zNzggNDMzYTggOCAwIDEgMSAxNiAwIDggOCAwIDAgMS0xNiAweiIvPjwvZGVmcz48Zz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzc3IC00MjQpIj48dXNlIGZpbGw9IiNmM2I0NDMiIHhsaW5rOmhyZWY9IiNjOG1tYSIvPjwvZz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzc3IC00MjQpIj48dXNlIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMCIgc3Ryb2tlPSIjZjNiNDQzIiBzdHJva2UtbWl0ZXJsaW1pdD0iNTAiIHhsaW5rOmhyZWY9IiNjOG1tYiIvPjwvZz48L2c+PC9zdmc+");
}
</style>